import React from 'react'

import styles from './typing.module.scss'

type Props = {
  displayParticipantsTyping: string
}

const Typing: React.FC<Props> = ({ displayParticipantsTyping }) => {
  return <p className={styles.typingIndicator}>{displayParticipantsTyping}</p>
}

export { Typing }
